/* eslint-disable default-param-last */
import { SHOW_USER_DETAILS } from 'actionTypes/userDetailsActionTypes';

const initialState = {
  status: false,
  selectedUser: null,
};

const userDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_USER_DETAILS:
      return {
        ...state,
        status: action.payload.status,
        selectedUser: action.payload.selectedUser,
      };

    default:
      return state;
  }
};

export default userDetailsReducer;
